import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { FormattedHTMLMessage } from 'react-intl'
import { compose } from 'recompose'

import { ConfigurationFile } from 'containers/misc'
import { List } from 'components/layout'
import { CONFIGURATION_KEYS } from 'constants/enums'
import { apiConfiguration } from 'helpers/decorators/api'
import { getApiVersion } from 'redux/modules/app'
import config from 'config'

import styles from './footer.styl'

const FOOTER_ORGANIZATION_ID = 1
const FOOTER_CONFIG_KEYS = [
  CONFIGURATION_KEYS.termsAndConditions.id,
  CONFIGURATION_KEYS.userGuideWebParticipant.id
]

const enhance = compose(
  connect(
    ({ app }) => ({
      apiVersion: app.apiVersion
    }),
    { getApiVersion }
  ),
  apiConfiguration()
)

class Footer extends Component {
  static propTypes = {
    getApiVersion: PropTypes.func,
    apiVersion: PropTypes.string,
    onGetConfigurationValues: PropTypes.func
  }

  componentDidMount() {
    this.props.getApiVersion()
    this.props.onGetConfigurationValues(FOOTER_CONFIG_KEYS, FOOTER_ORGANIZATION_ID, true)
  }

  render() {
    const { apiVersion } = this.props
    const year = new Date().getFullYear()

    return (
      <footer className={styles.footer}>
        <FormattedHTMLMessage
          id="footer.copyright"
          defaultMessage="&copy; Copyright The Duke of Edinburgh's International Award 2016"
          values={{
            year
          }}
        />

        <List inline>
          <ConfigurationFile
            configKey={CONFIGURATION_KEYS.termsAndConditions.id}
            organizationId={FOOTER_ORGANIZATION_ID}
            isPublic
            noFetch
            formattedName={
              <FormattedHTMLMessage
                id="button.terms_and_conditions"
                defaultMessage="International Terms & Conditions"
              />
            }
            inline
          />
          <ConfigurationFile
            configKey={CONFIGURATION_KEYS.userGuideWebParticipant.id}
            organizationId={FOOTER_ORGANIZATION_ID}
            isPublic
            noFetch
            formattedName={
              <FormattedHTMLMessage
                id="label.user_guide"
                defaultMessage="User guide"
              />
            }
            inline
          />
          {false && <span className="visible-xs">
            <ConfigurationFile
              configKey={CONFIGURATION_KEYS.faqDocuments.id}
              organizationId={1}
              isPublic
              formattedName={
                <FormattedHTMLMessage
                  id="label.frequently_asked_questions"
                  defaultMessage="Frequently asked questions"
                />
              }
              inline
            />
          </span>}
        </List>
        {apiVersion &&
          <small className={styles.apiVersion}>
            API version: <strong>{apiVersion}</strong>
            <br />
            Web version: <strong>{config.webVersion}</strong>
          </small>}
      </footer>
    )
  }
}

export default enhance(Footer)
